import React, { Component, useEffect } from 'react'
import AutoFavoriteModal from './AutoFavorite'
import ConfirmationLocation from './ConfirmationLocation'
import ContactUsSidebar from '../contact-us/ContactUsSidebar'
import FriendsPanel from '../community/FriendsPanel'
import PiggyBank from '../community/PiggyBank'
import flatten from 'lodash/flatten'
import uniqBy from 'lodash/uniqBy'
import { ArticleLarge, SpinnerCard } from '../common/Layout'
import { DailyLink } from '../home/DailyLink'
import { LocationOrderStatus } from '../common/Location'
import { OrderSummary, OrderDetails } from '../common/OrderSummary'
import { SimpleSpinner } from '../common/SimpleSpinner'
import { closeAutoFavorite } from '../../redux/modules/checkout'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import { loadDeliveryDropoffStart } from '../../redux/modules/delivery'
import { loadMenuStart } from '../../redux/modules/order'
import { loadReasonsByOrder, submitTicket } from '../../redux/modules/ticket'
import { updateModalStart } from '../../redux/modules/profile'
import { useStateValue } from '../../providers/ProviderCheckout'
import {
  loadFriendsStart,
  getFriendsOrdersStart,
  loadFriendsAtDateTimeStart,
} from '../../redux/modules/friends'
import {
  checkPiggybankStatusStart,
  checkDailyLinkStatusStart,
  referralsStatus,
} from '../../redux/modules/featureToggles'
import {
  loadFavoriteStart,
  deleteFavoriteStart,
  addFavoriteStart,
} from '../../redux/modules/favorite'
import {
  loadOrderStart,
  loadOrderByIdStart,
} from '../../redux/modules/orderDetail'
import { CopyReferral } from '../../components/common/FriendRequest'
import { Card } from '@foodsby/nutrient-v3'

const OrderStatus = ({ order }) => {
  return (
    <h1 className="row center-xs">
      <LocationOrderStatus
        extraClasses={{ confirm: true }}
        isConfirmation
        locationStatusClasses="order-status"
        order={order}
        statusText={
          !order.isPastCutoff && order.statusText !== 'Order Cancelled'
            ? 'Thank you for your order!'
            : order.statusText
        }
      />
    </h1>
  )
}

class Confirmation extends Component {
  constructor(props) {
    super(props)
    let {
      match: {
        params: { orderId, locationId },
      },
      history: {
        location: { state },
      },
      loadOrderByIdStart,
      loadReasonsByOrder,
      loadFriendsStart,
      checkPiggybankStatusStart,
      checkDailyLinkStatusStart,
    } = this.props
    loadOrderByIdStart(orderId)
    loadReasonsByOrder(orderId)
    loadFriendsStart()
    checkPiggybankStatusStart(locationId)
    checkDailyLinkStatusStart(locationId)
    let timer = setInterval(() => loadOrderByIdStart(orderId), 600000)
    this.state = {
      timer,
      showOrderSummary: false,
      hideFirstOrderModal: state && state.hideFirstOrderModal,
    }
    this.getIsReferralEnabled(locationId)
  }

  componentDidMount() {
    window && window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps) {
    let {
      match: {
        params: { locationId },
      },
      order,
      getFriendsOrdersStart,
      loadMenuStart,
      loadDeliveryDropoffStart,
      loadFavoriteStart,
      loadOrderStart,
    } = this.props
    if (
      (!prevProps.order && order) ||
      (order && order.orderId !== prevProps.order.orderId)
    ) {
      getFriendsOrdersStart(format(order.orderDate, 'YYYY-MM-DD'), locationId)
      loadOrderStart(format(order.orderDate, 'YYYYMMDD'), locationId)
      loadMenuStart(order.deliveryDropoffId)
      loadDeliveryDropoffStart(order.deliveryDropoffId)
      loadFavoriteStart()
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.timer)
  }

  toggleShowOrderSummary = () => {
    this.setState({ showOrderSummary: !this.state.showOrderSummary })
  }

  getIsReferralEnabled = async locationId => {
    const enabled = await referralsStatus(locationId)
    this.setState({ referralEnabled: enabled })
  }

  render() {
    const {
      order,
      orders,
      loading,
      profile,
      updatingModal,
      updateModalStart,
      favorites,
      addFavoriteStart,
      deleteFavoriteStart,
      favoriteInfo,
      autoFavorite,
      isLoadingFavorites,
      closeAutoFavorite,
      submitting,
      reasons,
      submitTicket,
      friends,
      friendNotOrdered,
      isLoadingFriendsOrders,
      friendsOrderCount,
      isCheckingStatus,
      piggybankStatus,
      menuItemIdsLoading,
      friendsAtOrderDelivered,
      loadFriendsAtDateTimeStart,
      isWebpSupported,
      history,
      dailyLinkStatus,
      match: {
        params: { locationId },
      },
    } = this.props

    let autoFavorites = []
    order &&
      favoriteInfo &&
      favoriteInfo.forEach(info => {
        autoFavorites = autoFavorites.concat(
          order.orderItems.filter(item => item.menuItemId === info.menuItemId),
        )
      })
    return (
      <ConfirmationComponent
        addFavoriteStart={addFavoriteStart}
        autoFavorite={autoFavorite}
        autoFavorites={autoFavorites}
        closeAutoFavorite={closeAutoFavorite}
        dailyLinkStatus={dailyLinkStatus}
        deleteFavoriteStart={deleteFavoriteStart}
        favorites={favorites}
        friendNotOrdered={friendNotOrdered}
        friends={friends}
        friendsAtOrderDelivered={friendsAtOrderDelivered}
        friendsOrderCount={friendsOrderCount}
        hideFirstOrderModal={this.state.hideFirstOrderModal}
        history={history}
        isCheckingStatus={isCheckingStatus}
        isLoadingFavorites={isLoadingFavorites}
        isLoadingFriendsOrders={isLoadingFriendsOrders}
        isWebpSupported={isWebpSupported}
        loadFriendsAtDateTimeStart={loadFriendsAtDateTimeStart}
        loading={loading}
        locationId={locationId}
        menuItemIdsLoading={menuItemIdsLoading}
        order={order}
        orders={orders}
        piggybankStatus={piggybankStatus}
        profile={profile}
        reasons={reasons}
        referralEnabled={this.state.referralEnabled}
        showOrderSummary={this.state.showOrderSummary}
        submitTicket={submitTicket}
        submitting={submitting}
        toggleShowOrderSummary={this.toggleShowOrderSummary}
        updateModalStart={updateModalStart}
        updatingModal={updatingModal}
      />
    )
  }
}

export const ConfirmationComponent = ({
  order,
  loading,
  profile,
  updatingModal,
  updateModalStart,
  favorites,
  addFavoriteStart,
  deleteFavoriteStart,
  closeAutoFavorite,
  autoFavorites,
  isLoadingFavorites,
  submitting,
  reasons,
  submitTicket,
  friends,
  friendNotOrdered,
  isLoadingFriendsOrders,
  friendsOrderCount,
  orders,
  isCheckingStatus,
  piggybankStatus,
  locationId,
  showOrderSummary,
  toggleShowOrderSummary,
  menuItemIdsLoading,
  friendsAtOrderDelivered,
  loadFriendsAtDateTimeStart,
  hideFirstOrderModal,
  isWebpSupported,
  dailyLinkStatus,
  history,
  referralEnabled,
}) => {
  const [{ subscription }, dispatch] = useStateValue()

  useEffect(() => {
    dispatch({
      type: 'setSubscription',
      newSubscription: {
        value: null,
      },
    })
  }, [dispatch, subscription.value])
  return (
    <ArticleLarge>
      <SpinnerCard
        spinnerActive={!order || !friends || isCheckingStatus || loading}
      >
        <OrderStatus order={order} />
        {piggybankStatus &&
          (isLoadingFriendsOrders ? (
            <SimpleSpinner />
          ) : (
            <>
              <hr />
              <PiggyBank
                {...{
                  friends,
                  friendsOrderCount:
                    friendsOrderCount &&
                    uniqBy(
                      friendsOrderCount.reduce(
                        (ordered, i) => ordered.concat(i.friend),
                        [],
                      ),
                      'userId',
                    ),
                  friendsAtOrderDelivered,
                  orders,
                  locationId,
                  activeOrders:
                    orders &&
                    orders.filter(order => order.orderState !== 'CANCELED'),
                  loadFriendsAtDateTimeStart,
                  selectedDate: order && format(order.orderDate, 'YYYY-MM-DD'),
                  profile,
                }}
                hideOrderStatus
                isWebpSupported={isWebpSupported}
                titleText={
                  orders &&
                  friendsOrderCount &&
                  orders.filter(order => order.orderState !== 'CANCELED')
                    .length >= 1 &&
                  flatten(friendsOrderCount).length >= 5
                    ? 'Earn Credit Daily'
                    : 'Want To Earn $1.00?'
                }
              />
              <FriendsPanel
                friendNotOrdered={friendNotOrdered}
                friends={friends}
                isWebpSupported={isWebpSupported}
              />
            </>
          ))}
      </SpinnerCard>
      <div className="row" style={{ margin: '0 -8px' }}>
        <div className="col-xs-12 col-md-8">
          <div
            style={{
              paddingBottom:
                dailyLinkStatus || referralEnabled ? '16px' : '0px',
            }}
          >
            {dailyLinkStatus ? (
              <DailyLink
                history={history}
                isAuthenticated
                locationId={locationId}
              />
            ) : (
              referralEnabled && (
                <Card className="WebConV3 referral-card">
                  <div className="referral-confirmation">
                    <CopyReferral
                      referralReward={referralEnabled.rewardAmountPennies / 100}
                    />
                    <p className="invite-friends-card-subhead">
                      Invite your work friends to Foodsby and you’ll both get a
                      ${referralEnabled.rewardAmountPennies / 100} credit when
                      they place their first order and it's delivered.
                    </p>
                  </div>
                </Card>
              )
            )}
          </div>
          <SpinnerCard
            spinnerActive={loading || isLoadingFavorites || submitting}
          >
            <ConfirmationLocation
              order={order}
              showOrderSummary={showOrderSummary}
              toggleShowOrderSummary={toggleShowOrderSummary}
            />
            {showOrderSummary && (
              <OrderSummary>
                {order && (
                  <OrderDetails
                    addFavoriteStart={addFavoriteStart}
                    deleteFavoriteStart={deleteFavoriteStart}
                    favorites={favorites}
                    menuItemIdsLoading={menuItemIdsLoading}
                    order={order}
                  />
                )}
              </OrderSummary>
            )}
            {autoFavorites.length >= 1 && (
              <AutoFavoriteModal
                closeAutoFavorite={closeAutoFavorite}
                items={autoFavorites}
              />
            )}
          </SpinnerCard>
        </div>
        <aside className="col-xs-12 col-md-4 confirmation-contact-us">
          <ContactUsSidebar
            className="contact-us-form"
            locationId={locationId}
            order={order}
            orderHistorySize
            reasons={reasons}
            showForm
            submitticket={submitTicket}
          />
        </aside>
      </div>
    </ArticleLarge>
  )
}

const mapStateToProps = state => {
  const { order, orders, loading } = state.orderDetail
  const { profile, updatingModal } = state.profile
  const { favorites, isLoadingFavorites, menuItemIdsLoading } = state.favorite
  const { favoriteInfo } = state.checkout
  const { submitting } = state.ticket
  const { reasons } = state
  const {
    friends,
    friendNotOrdered,
    isLoadingFriendsOrders,
    friendsOrderCount,
    isLoadingFriends,
    friendsAtOrderDelivered,
  } = state.friends
  const {
    isCheckingStatus,
    piggybankStatus,
    dailyLinkStatus,
  } = state.featureToggles
  const { isWebpSupported } = state.browser

  return {
    order,
    orders,
    loading,
    profile,
    updatingModal,
    favorites,
    favoriteInfo,
    isLoadingFavorites,
    submitting,
    reasons,
    friends,
    friendNotOrdered,
    isLoadingFriendsOrders,
    friendsOrderCount,
    isLoadingFriends,
    isCheckingStatus,
    piggybankStatus,
    menuItemIdsLoading,
    friendsAtOrderDelivered,
    isWebpSupported,
    dailyLinkStatus,
  }
}

const mapDispatchToProps = {
  loadOrderByIdStart,
  loadReasonsByOrder,
  updateModalStart,
  loadFavoriteStart,
  loadMenuStart,
  loadDeliveryDropoffStart,
  deleteFavoriteStart,
  addFavoriteStart,
  closeAutoFavorite,
  submitTicket,
  loadFriendsStart,
  getFriendsOrdersStart,
  loadOrderStart,
  checkPiggybankStatusStart,
  checkDailyLinkStatusStart,
  loadFriendsAtDateTimeStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation)
